/**
 * O "+" de uma saída livre: escolher o próximo passo, que entra à direita do
 * bloco, já ligado àquela saída. Os mesmos blocos da paleta, com busca.
 */

import { useId, useState, type ReactNode } from 'react';
import { Botao, Campo, Dialogo, Icone } from '@/shared/ui';
import { iconeDoTipo } from '../lib/aparencia';
import { buscarNaPaleta, type ItemDaPaleta } from '../lib/edicao';

const GRUPOS: { grupo: ItemDaPaleta['grupo']; titulo: string }[] = [
  { grupo: 'acao', titulo: 'Ações' },
  { grupo: 'logica', titulo: 'Lógica' },
  { grupo: 'espera', titulo: 'Esperas' },
  { grupo: 'dados', titulo: 'Dados' },
];

export function ProximoPasso({
  bloco,
  saida,
  itens,
  aoEscolher,
  aoFechar,
}: {
  bloco: string;
  saida: string;
  itens: readonly ItemDaPaleta[];
  aoEscolher: (item: ItemDaPaleta) => void;
  aoFechar: () => void;
}): ReactNode {
  const descricao = useId();
  const [busca, definirBusca] = useState('');
  const achados = buscarNaPaleta(itens, busca);
  return (
    <Dialogo
      titulo="Próximo passo"
      largura="estreita"
      descricaoId={descricao}
      aoFechar={aoFechar}
      botoes={
        <Botao variante="fantasma" onClick={aoFechar}>
          Cancelar
        </Botao>
      }
    >
      <div className="editor-do-mapa__proximo">
        <p className="editor-do-mapa__painel-ajuda" id={descricao}>
          Depois de “{saida}”, em {bloco}. O bloco entra à direita, já ligado.
        </p>
        <Campo
          type="search"
          icone="buscar"
          tamanho="miudo"
          rotuloOculto="Buscar bloco"
          placeholder="Buscar bloco"
          autoFocus
          value={busca}
          onChange={(e) => definirBusca(e.target.value)}
        />
        {achados.length === 0 && (
          <p className="editor-do-mapa__painel-ajuda">Nenhum bloco com “{busca.trim()}”.</p>
        )}
        {GRUPOS.map(({ grupo, titulo }) => {
          const doGrupo = achados.filter((i) => i.grupo === grupo);
          if (doGrupo.length === 0) return null;
          return (
            <section key={grupo} className="editor-do-mapa__paleta-grupo">
              <h3 className="editor-do-mapa__paleta-titulo">{titulo}</h3>
              <ul>
                {doGrupo.map((i) => (
                  <li key={i.chave}>
                    <button
                      type="button"
                      className="editor-do-mapa__paleta-item"
                      data-grupo={i.grupo}
                      onClick={() => aoEscolher(i)}
                    >
                      <span className="editor-do-mapa__paleta-icone" aria-hidden="true">
                        <Icone nome={iconeDoTipo(i.tipo)} />
                      </span>
                      <span className="editor-do-mapa__proximo-textos">
                        {i.titulo}
                        {i.descricao && (
                          <span className="editor-do-mapa__proximo-descricao">{i.descricao}</span>
                        )}
                      </span>
                    </button>
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
      </div>
    </Dialogo>
  );
}
